package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text

@Composable
fun SessionDayHeader(
    dayId: String,
    dateString: String,
    cardImageSrc: String? = null,
    width: Int? = null,
    height: Int? = null
) {
    // Dedicated anchor div at the very top of the session section
    Div(
        attrs = Modifier
            .id(dayId)
            .styleModifier {
                property("display", "block")
                property("height", "0")
                property("scroll-margin-top", "128px")
            }
            .toAttrs()
    ) {}

    H2 {
        Text(dateString)
    }

    cardImageSrc?.let { src ->
        val imgModifier = Modifier.maxWidth(100.percent).then(
            if (width == null || height == null) {
                Modifier
            } else {
                Modifier.width(width.px).height(height.px).styleModifier {
                    property("aspect-ratio", "$width / $height")
                    property("height", "auto")
                }
            }
        )
        LazyImg(
            src = src,
            alt = dateString,
            width = width,
            height = height,
            modifier = imgModifier
        )
    }
}
